import React, { Fragment } from 'react';
import { HOME } from 'src/routes/routes';
import { Link } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';
import Meta from 'src/components/Meta';
import { PageTitle } from 'src/components/Page';

const Error404Page = () => {
  const { t } = useTranslation();
  return (
    <Fragment>
      <Meta title={t('PAGE_NOT_FOUND')} />
      <PageTitle error={true}>
        <Trans>PAGE_NOT_FOUND</Trans>
        <Link to={HOME}>
          <Trans>PAGE_NOT_FOUND_LINK</Trans>
        </Link>
      </PageTitle>
    </Fragment>
  );
};

export default React.memo(Error404Page);
